/**
 * PersonalSpace Icon — "Persönlich" Life Space
 *
 * Rocket icon from Figma design.
 * Compatible with Lucide icon API (size + color props).
 *
 * @example
 * <PersonalSpaceIcon size={16} />
 */
export const PersonalSpaceIcon = ({ size = 16, color }: { size?: number; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 6L13.48 7.33C14.45 4.21 15 1 15 1C15 1 6.02 2.52 3.54 5.01C1.49 7.06 1.49 10.4 3.54 12.46C5.6 14.51 8.94 14.51 10.99 12.46C11.48 11.97 11.92 11.24 12.33 10.38L10.5 6Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 15L7.5 8.5"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
